import { ReactNode } from 'react';
import styles from './Button.module.scss';

const Button = ({
  children,
  disabled,
  onClick,
  paddingSmall,
}: {
  children: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  paddingSmall?: boolean;
}) => {
  return (
    <button
      className={
        paddingSmall ? styles.participateButtonSmall : styles.participateButton
      }
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
